<app-loader></app-loader>
<app-applicationloader></app-applicationloader>
<router-outlet></router-outlet>